exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-watching[data-v-65d42382]{height:100vh}", ""]);

// exports
